<template>
  <div class="comments-media-slider">
    <swiper class="swiper" :options="swiperOption" ref="swiper">
      <swiper-slide
        class="swiper-item comments-media-slider__photo-item"
        :class="{'product-comments-card__photo-item--video': item.video_id}"
        v-for="(item, i) in media"
        :key="i"
        @click.native="openCommentPhotoModal(item.video_id ? item.video_id : item.origin_photo)"
      >
        <div
          v-if="item.video_id"
          :style="{backgroundImage: `url(https://img.youtube.com/vi/${item.video_id}/sddefault.jpg)`}"
          class="swiper-lazy video-item__img"></div>
        <div v-if="item.video_id" class="play-video-btn"></div>
        <img
          v-else
          class="comments-media-slider__thumb-img"
          :src="item.thumb_photo"
          :alt="'фото-' + i + 1"
        />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'CommentsMediaSlider',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    media: Array,
    endpoint: {
      type: String,
      required: true
    },
    productId: {
      type: Number,
      default: null
    },
    isQuestions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        freeMode: true
      }
    }
  },
  methods: {
    openCommentPhotoModal (data) {
      this.$modal.show('comment-photo-modal', {
        data: data,
        endpoint: this.endpoint,
        productId: this.productId,
        isQuestions: this.isQuestions
      })
    }
  }
}
</script>

<style scoped lang="sass">

@import "../../styles/swiper/swiper"

.comments-media-slider
  position: relative
  width: 100%
  margin: 0 -15px 0 0

  +mmin($tablet--hor)
    padding: 20px
    border: 1px solid $nd-border-color
    border-radius: 3px

.swiper-container
  margin-right: -15px

  +mmin($tablet--hor)
    margin-right: auto

.comments-media-slider__photo-item
  display: flex
  align-items: center
  width: 70px
  height: 70px
  cursor: pointer
  position: relative
  border-radius: 3px
  overflow: hidden

  +mmin($tablet--hor)
    width: 80px
    height: 80px

.comments-media-slider__thumb-img
  display: block
  width: 100%
  height: 100%
  object-fit: cover

.play-video-btn
  width: 24px
  height: 24px

  &:before
    border-width: 4px 0 4px 6px

  &:hover
    background-color: $main-color

.video-item__img
  width: 70px
  height: 70px
  background-size: cover

  +mmin($tablet--hor)
    width: 80px
    height: 80px

.swiper-button-next,
.swiper-button-prev
  +mmax(1023)
    display: none
</style>
